<template>
    <div>
        <b-btn @click="() => open()" variant="primary">
            <i class="fa fa-plus mr-2"></i>
            {{ $t('button.Create') }}
        </b-btn>
        <b-modal
                ref="createModal"
                :no-close-on-backdrop="true"
                size="lg"
                :title="$t('fields.CreateEvent')"
                title-tag="h3"
                v-model="modalShow"
        >
            <div class="d-block text-center">
                <div class="alert alert-danger" v-if="error" id="error">{{$t(error)}}</div>
                <formly-form :form="form" :model="model" :fields="fields" ref="create"/>
                <div class="row">
                    <div class="form-group col-12">
                        <label>{{$t('fields.PriceOptions')}}</label>
                        <div class="input-group mb-3">
                            <input type="number" class="form-control" :placeholder="$t('fields.NeedPay')"
                                   v-model="needPay">
                            <input type="number" class="form-control" :placeholder="$t('fields.Deposit')"
                                   v-model="deposit">
                            <input type="text" class="form-control" :placeholder="$t('fields.Desc')"
                                   v-model="desc">
                            <div class="input-group-append">
                                <button class="btn btn-primary" type="button" id="button-add-price"
                                        @click="addPrice">
                                    {{$t('button.Add')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <ul class="list-group">
                            <li v-for="(price, index) in model.prices"
                                class="list-group-item d-flex justify-content-between align-items-center" :key="index">
                                {{$t('fields.NeedPay')}}: {{price.need_pay}}, {{$t('fields.Deposit')}}: {{price.deposit}}, {{$t('fields.Desc')}}: {{price.description}}
                                <button type="button" class="close" aria-label="Close"
                                        @click="(e) => deletePrice(e, index)">
                                    <i aria-hidden="true" class="fa fa-times"></i>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-6">
                        <label>{{$t('fields.BusTimeIn')}}</label>
                        <div class="input-group mb-3">
                            <input type="time" class="form-control" aria-label="add time" aria-describedby="button-add"
                                   v-model="timeIn">
                            <div class="input-group-append">
                                <button class="btn btn-primary" type="button" id="button-add"
                                        @click="addTimeIn">
                                    {{$t('button.Add')}}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-6">
                        <label>{{$t('fields.BusTimeOut')}}</label>
                        <div class="input-group">
                            <input type="time" class="form-control" aria-label="add time" aria-describedby="button-add"
                                   v-model="timeOut">
                            <div class="input-group-append">
                                <button class="btn btn-primary" type="button" id="button-add-out"
                                        @click="addTimeOut">
                                    {{$t('button.Add')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <ul class="list-group">
                            <li v-for="(time, index) in model.transportTimesIn"
                                class="list-group-item d-flex justify-content-between align-items-center" :key="time">
                                {{time}}
                                <button type="button" class="close" aria-label="Close"
                                        @click="(e) => deleteTime(e, index, 'in')">
                                    <i aria-hidden="true" class="fa fa-times"></i>
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div class="col-6">
                        <ul class="list-group">
                            <li v-for="(time, index) in model.transportTimesOut"
                                class="list-group-item d-flex justify-content-between align-items-center" :key="time">
                                {{time}}
                                <button type="button" class="close" aria-label="Close"
                                        @click="(e) => deleteTime(e, index, 'out')">
                                    <i aria-hidden="true" class="fa fa-times"></i>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div slot="modal-footer" class="w-100">
                <b-btn
                        size="sm"
                        :class="(disabled ? 'disabled': '')"
                        variant="secondary"
                        @click="modalShow = false"
                        :disabled="disabled"
                >
                    {{$t('button.Close')}}
                </b-btn>
                <b-btn
                        size="sm"
                        :class="(disabled ? 'disabled': '') + ' ml-3'"
                        variant="primary"
                        @click="submit"
                        :disabled="disabled"
                >
                    {{$t('button.Create')}}
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
  import isLength from 'validator/lib/isLength';
  import dayjs from 'dayjs';
  import {mapActions, mapGetters} from 'vuex';
  import {BButton} from 'bootstrap-vue/src/components/button/button';
  import {BModal} from 'bootstrap-vue/src/components/modal/modal';
  import {ROUTER_NAMES, ERROR_MESSAGES} from '../../constants';

  export default {
    components: {
      BModal: BModal,
      BBtn: BButton
    },
    computed: {
      ...mapGetters(['getVolunteerTypesOptions']),
    },
    data() {
      const volunteerTypeOptions = [];

      return {
        modalShow: false,
        disabled: false,
        error: '',
        form: {},
        timeOut: '',
        timeIn: '',
        needPay: '',
        deposit: '',
        desc: '',
        model: {
          name: '',
          theme: '',
          startRegistration: '',
          startDate: '',
          endDate: '',
          transportTimesIn: [],
          transportTimesOut: [],
          prices: [],
          volunteerTypes: ''
        },
        fields: [
          {
            key: 'name',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Name')
            },
            required: true,
            validators: {
              validName: {
                expression(field, model, next) {
                  next(isLength(model[field.key], {min: 3}));
                },
                message: this.$tc('validation.min', 3)
              }
            }
          },
          {
            key: 'theme',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Theme')
            },
            validators: {
              validTheme: {
                expression(field, model, next) {
                  next(!model[field.key] || isLength(model[field.key], {min: 3}));
                },
                message: this.$tc('validation.min', 3)
              }
            }
          },
          {
            key: 'type',
            type: 'multi-select',
            options: [{
              'label': 'Puť radosti',
              'value': 'pr'
            }, {
              'label': 'Puť zrelosti',
              'value': 'pz'
            }, {
              'label': 'Puť rodin',
              'value': 'prod'
            }, {
              'label': 'Festival radosti',
              'value': 'fest'
            }, {
              'label': 'Silvester',
              'value': 'silv'
            }, {
              'label': 'Víkend Dobrovolníkov',
              'value': 'dobr'
            },],
            templateOptions: {
              label: this.$t('fields.EventType'),
              multiple: false,
              closeOnSelect: true
            },
            required: true
          },
          {
            key: 'volunteerTypes',
            type: 'multi-select',
            options: volunteerTypeOptions,
            templateOptions: {
              label: this.$t('fields.VolunteerTypes'),
              multiple: true,
              closeOnSelect: false
            },
            required: true,
          },
          {
            key: 'startDate',
            type: 'date',
            templateOptions: {
              label: this.$t('fields.StartDate'),
              placeholder: this.$t('fields.StartDate')
            },
            validators: {
              validstartDate: {
                expression(field, model, next) {
                  next(dayjs(model[field.key])
                    .isAfter(dayjs()));
                },
                message: this.$t('validation.afterToday')
              }
            },
            required: true
          },
          {
            key: 'endDate',
            type: 'date',
            templateOptions: {
              label: this.$t('fields.EndDate'),
              placeholder: this.$t('fields.EndDate')
            },
            required: true,
            validators: {
              validDate: {
                expression(field, model, next) {
                  next(dayjs(model[field.key])
                    .isAfter(dayjs()));
                },
                message: this.$t('validation.afterToday')
              }
            }
          },
          {
            key: 'startRegistration',
            type: 'date',
            templateOptions: {
              label: this.$t('fields.StartRegistrationDate'),
              placeholder: this.$t('fields.StartRegistrationDate')
            },
            required: true,
            validators: {
              validDate: {
                expression(field, model, next) {
                  next(dayjs(model[field.key])
                    .isAfter(dayjs()));
                },
                message: this.$t('validation.afterToday')
              }
            }
          },
          {
            key: 'endRegistration',
            type: 'date',
            templateOptions: {
              label: this.$t('fields.EndRegistrationDate'),
              placeholder: this.$t('fields.EndRegistrationDate')
            },
            required: true,
            validators: {
              validDate: {
                expression(field, model, next) {
                  next(dayjs(model[field.key])
                    .isAfter(dayjs()));
                },
                message: this.$t('validation.afterToday')
              }
            }
          },
          {
            key: 'endVolunteerRegistration',
            type: 'date',
            templateOptions: {
              label: this.$t('fields.EndVolunteerRegistrationDate'),
              placeholder: this.$t('fields.EndVolunteerRegistrationDate')
            },
            required: true,
            validators: {
              validDate: {
                expression(field, model, next) {
                  next(dayjs(model[field.key])
                    .isAfter(dayjs()));
                },
                message: this.$t('validation.afterToday')
              }
            }
          }
        ]
      };
    },
    methods: {
      ...mapActions(['createEvent', 'loadVolunteerTypes']),
      open() {
        this.modalShow = !this.modalShow;
        const volunteerOptions = this.getVolunteerTypesOptions;
        this.fields = [
          {
            key: 'name',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Name')
            },
            required: true,
            validators: {
              validName: {
                expression(field, model, next) {
                  next(isLength(model[field.key], {min: 3}));
                },
                message: this.$tc('validation.min', 3)
              }
            }
          },
          {
            key: 'theme',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Theme')
            },
            validators: {
              validTheme: {
                expression(field, model, next) {
                  next(!model[field.key] || isLength(model[field.key], {min: 3}));
                },
                message: this.$tc('validation.min', 3)
              }
            }
          },
          {
            key: 'type',
            type: 'multi-select',
            options: [{
              'label': 'Puť radosti',
              'value': 'pr'
            }, {
              'label': 'Puť zrelosti',
              'value': 'pz'
            }, {
              'label': 'Puť rodin',
              'value': 'prod'
            }, {
              'label': 'Festival radosti',
              'value': 'fest'
            }, {
              'label': 'Silvester',
              'value': 'silv'
            }, {
              'label': 'Víkend Dobrovolníkov',
              'value': 'dobr'
            },],
            templateOptions: {
              label: this.$t('fields.EventType'),
              multiple: false,
              closeOnSelect: true
            },
            required: true
          },
          {
            key: 'volunteerTypes',
            type: 'multi-select',
            options: volunteerOptions,
            templateOptions: {
              label: this.$t('fields.VolunteerTypes'),
              multiple: true,
              closeOnSelect: false
            },
            required: true,
          },
          {
            key: 'startDate',
            type: 'date',
            templateOptions: {
              label: this.$t('fields.StartDate'),
              placeholder: this.$t('fields.StartDate')
            },
            validators: {
              validstartDate: {
                expression(field, model, next) {
                  next(dayjs(model[field.key])
                    .isAfter(dayjs()));
                },
                message: this.$t('validation.afterToday')
              }
            },
            required: true
          },
          {
            key: 'endDate',
            type: 'date',
            templateOptions: {
              label: this.$t('fields.EndDate'),
              placeholder: this.$t('fields.EndDate')
            },
            required: true,
            validators: {
              validDate: {
                expression(field, model, next) {
                  next(dayjs(model[field.key])
                    .isAfter(dayjs()));
                },
                message: this.$t('validation.afterToday')
              }
            }
          },
          {
            key: 'startRegistration',
            type: 'date',
            templateOptions: {
              label: this.$t('fields.StartRegistrationDate'),
              placeholder: this.$t('fields.StartRegistrationDate')
            },
            required: true,
            validators: {
              validDate: {
                expression(field, model, next) {
                  next(dayjs(model[field.key])
                    .isAfter(dayjs()));
                },
                message: this.$t('validation.afterToday')
              }
            }
          },
          {
            key: 'endRegistration',
            type: 'date',
            templateOptions: {
              label: this.$t('fields.EndRegistrationDate'),
              placeholder: this.$t('fields.EndRegistrationDate')
            },
            required: true,
            validators: {
              validDate: {
                expression(field, model, next) {
                  next(dayjs(model[field.key])
                    .isAfter(dayjs()));
                },
                message: this.$t('validation.afterToday')
              }
            }
          },
          {
            key: 'endVolunteerRegistration',
            type: 'date',
            templateOptions: {
              label: this.$t('fields.EndVolunteerRegistrationDate'),
              placeholder: this.$t('fields.EndVolunteerRegistrationDate')
            },
            required: true,
            validators: {
              validDate: {
                expression(field, model, next) {
                  next(dayjs(model[field.key])
                    .isAfter(dayjs()));
                },
                message: this.$t('validation.afterToday')
              }
            }
          }
        ];
      },
      getTransportTimesArray(type) {
        if (type === 'in') {
          return this.model.transportTimesIn;
        }

        return this.model.transportTimesOut;
      },
      addTimeIn(e) {
        e.preventDefault();

        this.model.transportTimesIn.push(this.timeIn);
        this.timeIn = '';
      },
      addPrice(e) {
        e.preventDefault();
        if (this.needPay && parseInt(this.needPay) > 0 && this.deposit && parseInt(this.deposit) > 0 ) {
          this.model.prices.push({
            need_pay: this.needPay,
            deposit: this.deposit,
            description: this.desc
          })
          this.needPay = 0;
          this.deposit = 0;
          this.desc = '';
        }
      },
      deletePrice(e, index) {
        e.preventDefault();
        this.model.prices.splice(index, 1);
      },
      addTimeOut(e) {
        e.preventDefault();

        this.model.transportTimesOut.push(this.timeOut);
        this.timeOut = '';
      },
      deleteTime(e, index, type) {
        e.preventDefault();

        this.getTransportTimesArray(type)
          .splice(index, 1);
      },
      submit(e) {
        e.preventDefault();
        this.$refs.create.validate()
          .then(() => {
            if (!this.form.$valid) return;
            if (!this.model.prices.length) {
                this.error = 'errorMessages.PRICE_MUST_BE_DEFINED';
                $('.modal').scrollTop(0);
                return;
            }
            this.disabled = true;
            var data = {
              ...this.model
            };

            data.volunteerTypes = data.volunteerTypes.map((item) => item.value);
            data.type = this.model.type ? this.model.type.value : null;

            data.startDate = dayjs(data.startDate)
              .format('YYYY-MM-DD');
            data.startRegistration = dayjs(data.startRegistration)
              .format('YYYY-MM-DD');
            data.endDate = dayjs(data.endDate)
              .format('YYYY-MM-DD');
            data.endVolunteerRegistration = dayjs(data.endVolunteerRegistration)
              .format('YYYY-MM-DD');
            data.endRegistration = dayjs(data.endRegistration)
              .format('YYYY-MM-DD');

            this.createEvent(data)
              .then(response => {
                this.disabled = false;
                this.modalShow = false;
                //TODO: to this trough emit to load events
                this.$router.push({
                  name: ROUTER_NAMES.ADMIN_EVENTS,
                  replace: true
                });
              })
              .catch(() => {
                this.disabled = false;
                this.$router.push({
                  name: ROUTER_NAMES.ERROR
                });
              });
          });
      }
    }
  };
</script>


<style>
</style>
